import { Component } from "react";
import Table from 'react-bootstrap/Table';


class NaiveModelAccuracyTable extends Component {
  static Title = "Naïve model accuracy statistics"
    render() {
        return (
<Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Dataset</th>              
                    <th>Samples</th>              
                    <th>R2</th>              
                    <th>RMSE (%)</th>              
                    <th>MAE (%)</th>              
                    <th>Median (Error)</th>              
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Training</td>
                    <td>147</td>
                    <td>-</td>
                    <td>22.500</td>
                    <td>18.416</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Tuning</td>
                    <td>72</td>
                    <td>-</td>
                    <td>21.846</td>
                    <td>17.889</td>
                    <td>-</td>
                  </tr>                                  
                </tbody>
          </Table>                       
                    );
    }
}
export default NaiveModelAccuracyTable 